import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../../../utils/api";
import { getErrorMessage } from "../../../../utils/helpers/errors";

export const getAbsenceImpactUrl = (userId) => `/request/absence-impact/${userId}`;
export const getAbsenceShiftActionsUrl = (userId) => `/schedules/v2/user/${userId}/resolve-absence-shifts`;

export const useAbsenceImpact = (userId) => {
    const { t } = useTranslation();
    const { authPost } = useApi();
    const [checkingImpact, setCheckingImpact] = useState(false);

    const checkImpact = useCallback(
        async (data) => {
            setCheckingImpact(true);
            try {
                return await authPost(getAbsenceImpactUrl(userId), { data });
            } catch (error) {
                getErrorMessage(error, t);
                throw error;
            } finally {
                setCheckingImpact(false);
            }
        },
        [authPost, userId, t]
    );

    const applyShiftActions = useCallback(
        async (shifts) => {
            if (!shifts?.length) return [];
            try {
                const response = await authPost(getAbsenceShiftActionsUrl(userId), { data: { shifts } });
                return response?.results ?? [];
            } catch (error) {
                getErrorMessage(error, t);
                return [];
            }
        },
        [authPost, userId, t]
    );

    return { checkImpact, checkingImpact, applyShiftActions };
};
